<ngx-spinner name="upsSpinner" bdColor="rgba(255, 255, 255, 0.8)" size="medium" color="#321815" type="custom" [fullScreen]="true">
  <app-spinner></app-spinner>
</ngx-spinner>
@if (isLoading) {
  <div class="spinner-container">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}

<!-- Main Container -->
<div class="main-container">
  <!-- Template Button in Top Right -->
  @if (!excelData.length) {
    <div class="template-button-container">
      <button class="template-button" (click)="downloadTemplate()">
        <i class="material-icons">file_download</i> Template
      </button>
    </div>
  }

  <!-- Upload Section (shown only when no data is loaded) -->
  @if (!excelData?.length) {
    <div class="upload-container">
      <div class="upload-card">
        <div class="upload-icon">
          <i class="material-icons">cloud_upload</i>
        </div>
        <h2>Upload Excel File</h2>
        <button class="upload-button" (click)="fileInput.click()">
          <input
            #fileInput
            type="file"
            (change)="onFileChange($event)"
            accept=".xlsx, .xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            class="hidden-input" />
            <i class="material-icons">file_upload</i> Select File
          </button>
          <p class="file-types">Supports: .xlsx, .xls (Max 10MB)</p>
        </div>
      </div>
    }

    <!-- File Info (shown after file is confirmed) -->
    @if (selectedFile && isFileConfirmed) {
      <div class="file-info">
        <div class="file-header">
          <!-- 📄 File Name -->
          <div class="file-details">
            <i class="material-icons file-icon">insert_drive_file</i>
            <div class="file-info-text">
              <span class="file-name" [title]="selectedFile.name">{{ selectedFile.name }}</span>
            </div>
          </div>
          <!-- 📤 Buttons to right -->
          <div class="top-right-buttons">
            @if (excelData.length) {
              <button class="reupload-btn" (click)="clearFile()">
                <i class="material-icons">file_upload</i> Re-upload
              </button>
            }
            @if (excelData.length) {
              <button class="reupload-btn" (click)="submitRequest()">
                <i class="material-icons">save</i> Submit
              </button>
            }
          </div>
        </div>
      </div>
    }

    <!-- Loading Overlay -->
    @if (isLoading) {
      <div class="progress-overlay">
        <div class="circular-progress-circle" [class]="getProgressClass()">
          <div class="circular-progress-inner">
            <div class="progress-value">{{ progress }}%</div>
            <div class="progress-text">Loading</div>
          </div>
        </div>
        <div class="text-primary mt-3">
          {{ processingMessage }}
        </div>
      </div>
    }

    <!-- Data View -->
    @if (excelData.length > 0 || isLoading) {
      <div class="mt-3">
        <!-- Tables -->
        @if (!isLoading && topData.length > 0) {
          <div>
            <mi-table
              [data]="topData"
              [searchText]="searchText"
              [isSearchRequired]="false"
              [validationRules]="firstTableValidationRules"
              (rowUpdated)="onRowUpdate($event)"
              (rowEditCanceled)="onRowEditCancel($event)"
              (actionEvent)="handleAction($event)"
              (validationError)="onValidationError($event)"
              [actions]="true"
              [nonEditableFields]="['# of customers','Adjustment Type','Amount']"
              [allowedActions]="['edit']">
            </mi-table>
          </div>
        }
        @if (!isLoading && excelData.length > 0) {
          <div>
            <mi-table
              [data]="excelData"
              [searchText]="searchText"
              [isSearchRequired]="true"
              [validationRules]="tableValidationRules"
              (rowUpdated)="onRowUpdate($event)"
              (rowEditCanceled)="onRowEditCancel($event)"
              (actionEvent)="handleAction($event)"
              (validationError)="onValidationError($event)"
              [actions]="true"
              [nonEditableFields]="['Adjustment Method']"
              [allowedActions]="['edit']">
            </mi-table>
          </div>
        }
        <!-- Commented code kept as is -->
        <!-- <div class="save-request-container" *ngIf="excelData.length > 0">
        <button class="save-request-btn" (click)="submitRequest()">
          <i class="material-icons">save</i> Submit
        </button>
      </div>
      <mat-card class="result">
        <mat-card-content>
          <div class="example-full-width fs-14">
            <input type="file" multiple (change)="getFileDetails($event)" class="hidden-input" #fileInput />
            <button type="button" class="custom-button" (click)="fileInput.click()" [disabled]="selectedFiles.length > 5">Select Files</button>
            <mat-icon *ngIf="savedData!=null" (click)="download()" class="download-icon" matTooltip="Download Uploaded Files" svgIcon="thumbs-up" aria-hidden="false" aria-label="Example thumbs up SVG icon"></mat-icon>
            <span class="error-text"> {{fileErrors}} </span>
            <br/><span class="hint-text small">Supported file type(s): csv, pdf, txt, xlsx, eml, msg</span>
            <br/>
            <span class="hint-text small">Size limit: 500MB per file, upto 5 files.</span>
            <div *ngFor="let file of selectedFiles; let i = index">
              <div class="file-name-box">{{ file.name }}
                <button type="button" class="close delete-btn" aria-label="Close" (click)="removeFile(i)">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card> -->
      <!-- Submit + File Upload in One Row -->
      @if (excelData.length > 0) {
        <div class="submit-upload-row">
          <!-- Row 1: Selected files shown horizontally -->
          <div class="selected-files-wrapper full-width-row">
            @for (file of selectedFiles; track file; let i = $index) {
              <div class="selected-file-list">
                <div class="file-name-box">
                  {{ file.name }}
                  <button type="button" class="close delete-btn" aria-label="Close" (click)="removeFile(i)">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            }
          </div>
          <!-- Row 2: Select Files on left, Submit on right -->
          <div class="button-row full-width-row">
            <!-- Select Files Button -->
            <div class="select-files-container">
              <input type="file" multiple (change)="getFileDetails($event)" class="hidden-input" #fileInput />
              <button type="button" class="custom-button same-size-btn" (click)="fileInput.click()" [disabled]="selectedFiles.length > 5">
                <i class="material-icons">attach_file</i> Select Files
              </button>
            </div>
            <!-- Submit Button -->
            <div class="submit-btn-container">
              <button class="save-request-btn same-size-btn" (click)="submitRequest()">
                <i class="material-icons">save</i> Submit
              </button>
            </div>
          </div>
        </div>
      }
      <!-- Optional: File validation messages below -->
      @if (excelData.length > 0) {
        <div class="file-upload-info">
          <span class="text-danger"> {{ fileErrors }} </span><br />
          <span class="hint-text">Supported file types: csv, pdf, txt, xlsx, eml, msg</span><br />
          <span class="hint-text">Size limit: 500MB per file, up to 5 files.</span>
        </div>
      }
    </div>
  }
</div>
